import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getGetBulkBundleQueryOptions } from "@/requests/gen/react-query/bulk-bundle";
import { BulkBundleCrumbs } from "../../-crumbs";
import BulkBundleProductsForm from "./-form";
import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_practice-360/bulk-bundle/$bulkBundleId/products/",
)({
  loader: ({ context: { queryClient }, params: { bulkBundleId } }) =>
    queryClient.ensureQueryData(
      getGetBulkBundleQueryOptions(numericId(bulkBundleId)),
    ),
  component: BulkBundleComponentsPage,
});

function BulkBundleComponentsPage() {
  const { bulkBundleId } = Route.useParams();
  const { data: bulkBundle } = useSuspenseQuery(
    suspenseOptions(getGetBulkBundleQueryOptions(numericId(bulkBundleId))),
  );

  return (
    <div>
      <title>{`${bulkBundle?.name} - Legrande Health Portal`}</title>
      <BulkBundleCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Bulk Bundle Products</CardTitle>
          <CardDescription>
            Add or modify the bulk products that make up this bundle.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {bulkBundle && <BulkBundleProductsForm bulkBundle={bulkBundle} />}
        </CardContent>
      </Card>
    </div>
  );
}
